<template>
  <FourElement />
  <div class="collection-container">
    <List />
    <div v-if="dataSource && dataSource.length > 0">
      <div class="fs14 lh30 fl" style="color: #999999;">
        {{
          `共 ${pagination.total} 条记录，第${pagination.pageNum} / ${~~(
            pagination.total / pagination.pageSize
          ) +
            (pagination.total % pagination.pageSize
              ? 1
              : pagination.total === 0
              ? 1
              : 0)}页`
        }}
      </div>
      <div
        style="display: flex; flex-direction: row; float: right; padding-bottom: 50px;"
      >
        <a-pagination
          v-if="pagination.pageSize"
          class="mr20"
          v-model:current="pagination.pageNum"
          :total="pagination.total"
          v-model:pageSize="pagination.pageSize"
          :showTotal="() => false"
          :showSizeChanger="false"
          @change="initList"
        />
        <a-select
          class="mr10"
          style="min-width: 80px;"
          v-model:value="pagination.pageSize"
          @change="initList"
          placeholder="条"
          :options="[
            { value: 10, label: 10 },
            { value: 20, label: 20 },
            { value: 30, label: 30 },
            { value: 40, label: 40 },
            { value: 50, label: 50 }
          ]"
        >
        </a-select>
        <div class="lh30 mr10">条/页</div>
        <div class="lh30 mr10">跳转至</div>
        <a-input-number
          class="mr10"
          style="width: 50px;"
          :value="pagination.pageNum"
          placeholder="页"
          :max="
            pagination.total <= pagination.pageSize
              ? 1
              : Math.ceil(pagination.total / pagination.pageSize)
          "
          :min="1"
          @change="watchPage"
        />
        <div class="lh30">页</div>
      </div>
    </div>
  </div>
  <SideBar />
  <CoverList />
</template>
<script>
import { toRefs, reactive, provide, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import FourElement from './components/FourElement'
import SideBar from './components/SideBar'
import List from './components/List'
import CoverList from './components/CoverList'
import useAPI from 'UseApi'
// import { message } from 'ant-design-vue'
const {
  common_querySiteInfo_get_,
  col_activeCol_post_,
  col_queryColLog_post_,
  newSize_getTypes_post_copy,
  buyitwith_list_post_,
  buyitwith_save_post_,
  buyitwith_page_post_,
  buyitwith_modify_post_,
  buyitwith_delete_id_get_,
  buyitwith_query_id_get_
} = useAPI(null, [3426, 4240, 5922, 7595, 4243])
export default {
  components: {
    FourElement,
    SideBar,
    List,
    CoverList
  },
  setup() {
    const state = reactive({
      flatAllTypes: [],
      coverDataSource: [],
      repeatTest: () => {
        let params = {
          ...state.postParams
        }
        params.mainSkcCategory = params.mainSkcCategory
          ? params.mainSkcCategory.join(',')
          : null
        buyitwith_list_post_(params, state)
      },
      flatFun: list => {
        let emp = []
        list.map(v => {
          const { categoryId, parentId, typeName } = v
          emp.push({ categoryId, parentId, typeName })
          if (v.nextLevelList && v.nextLevelList.length) {
            emp = [...emp, ...state.flatFun(v.nextLevelList)]
          }
        })
        return emp
      },
      filterId: categoryId => {
        let flatAllTypes = [...state.flatAllTypes]
        let checkVal = flatAllTypes.filter(v => v.categoryId === categoryId)[0]
        if (checkVal && checkVal.parentId) {
          let perCheckVal = flatAllTypes.filter(
            v => v.categoryId === checkVal.parentId
          )[0]
          if (perCheckVal && perCheckVal.parentId) {
            return `${perCheckVal.parentId},${checkVal.parentId},${categoryId}`
          } else {
            return `${checkVal.parentId},${categoryId}`
          }
        } else {
          return `${categoryId}`
        }
      },
      mapFilterId: (list = []) => {
        if (!list.length) return []
        let empList = []
        list.map(v => {
          empList.push(state.filterId(v))
        })
        return empList
      },
      getDetail: () => {
        const {
          mapFilterId,
          categories1,
          categories2,
          categories3,
          categories4,
          categories5
        } = state
        return [
          { categories: mapFilterId(categories1), position: 1 },
          { categories: mapFilterId(categories2), position: 2 },
          { categories: mapFilterId(categories3), position: 3 },
          { categories: mapFilterId(categories4), position: 4 },
          { categories: mapFilterId(categories5), position: 5 }
        ]
      },
      save: () => {
        state.changeCoverVisible(false)
        let params = {
          ...state.postParams
        }
        params.mainSkcCategory = params.mainSkcCategory
          ? params.mainSkcCategory.join(',')
          : null
        params.details = state.getDetail()
        buyitwith_save_post_(params, state)
      },
      modify: () => {
        let params = {
          id: state.record.id
        }
        params.details = state.getDetail()
        buyitwith_modify_post_(params, state)
      },
      fieldNames: {
        label: 'typeName',
        value: 'categoryId',
        children: 'nextLevelList'
      },
      allTypes: [],
      cascaderOptions: [],
      getTypes: () => {
        newSize_getTypes_post_copy(
          { brandId: 1, channelId: 1, siteId: 1, terminalId: 1 },
          state
        )
      },
      coverVisible: false,
      changeCoverVisible: (visible = false) => {
        state.coverVisible = visible
      },
      terminalOptions: [
        { value: 1, label: 'WEB' },
        { value: 2, label: 'APP' }
      ],
      siteBarVisible: false,
      record: null,
      edit: false,
      changeVisible: (visible = false, record = null) => {
        state.record = record
        state.edit = record ? true : false
        if (record) {
          buyitwith_query_id_get_({ id: record.id }, state)
        } else {
          state.siteBarVisible = visible
        }
        if (!visible) {
          state.postParams = {
            siteName: null,
            terminalName: null,
            month: null,
            siteIds: [], // 站点ID
            terminalIds: [], // 终端ID
            months: [], // 月份
            mainSkcCategory: [], // 主商品二级类目ID
            details: [] // 坑位列表
          }
          state.categories1 = []
          state.categories2 = []
          state.categories3 = []
          state.categories4 = []
          state.categories5 = []
        }
      },
      warningAlert: true,
      handleHoverChange: visible => {
        state.clicked = false
        state.hovered = visible
      },
      handleClickChange: visible => {
        state.clicked = visible
        state.hovered = false
      },
      hide: () => {
        state.clicked = false
        state.hovered = false
      },
      watchPage: e => {
        state.pagination.pageNum = e
        state.initList()
      },
      col_activeCol_post: params => {
        col_activeCol_post_(params, state.initList)
      },
      col_queryColLog_post: params => {
        if (params.colId) {
          state.colId = params.colId
        }

        col_queryColLog_post_({ ...params }, state)
      },
      deleteFun: params => {
        const { id } = params
        buyitwith_delete_id_get_({ id }, state)
      },
      value: null,
      route: useRoute(),
      router: useRouter(),
      jumpPage: (path, query) => {
        console.log('query ', query)
        state.router.push({ path, query })
      },
      dataSource: [],
      searchParams: {
        terminalIds: [1, 2],
        siteIds: [1],
        months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
      },
      brands: [],
      channels: [],
      sites: [],
      postParams: {
        siteName: null,
        terminalName: null,
        month: null,
        siteIds: [], // 站点ID
        terminalIds: [], // 终端ID
        months: [], // 月份
        mainSkcCategory: null, // 主商品二级类目ID
        details: [] // 坑位列表
      },
      categories1: [],
      categories2: [],
      categories3: [],
      categories4: [],
      categories5: [],
      pagination: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页的数量
        total: 0 // 总记录数
      },
      resetPagination: () => {
        state.pagination = {
          pageNum: 1, // 当前页
          pageSize: 10, // 每页的数量
          total: 0 // 总记录数
        }
        state.initList()
      },
      logList: [],
      logPagination: {
        pageNum: 1, // 当前页
        pageSize: 5, // 每页的数量
        total: 0 // 总记录数
      },
      monthOptions: [
        {
          value: 1,
          label: '1月'
        },
        {
          value: 2,
          label: '2月'
        },
        {
          value: 3,
          label: '3月'
        },
        {
          value: 4,
          label: '4月'
        },
        {
          value: 5,
          label: '5月'
        },
        {
          value: 6,
          label: '6月'
        },
        {
          value: 7,
          label: '7月'
        },
        {
          value: 8,
          label: '8月'
        },
        {
          value: 9,
          label: '9月'
        },
        {
          value: 10,
          label: '10月'
        },
        {
          value: 11,
          label: '11月'
        },
        {
          value: 12,
          label: '12月'
        }
      ],
      initList: () => {
        let params = { ...state.searchParams, ...state.pagination }
        buyitwith_page_post_(params, state)
      }, // 初始化标题列表
      init: () => {
        let sites = state.sites
        let siteIds = []
        sites.map(v => {
          siteIds.push(v.id)
        })
        state.searchParams.siteIds = siteIds
        state.initList()
      }
    })
    onMounted(() => {
      common_querySiteInfo_get_(
        {
          state
        },
        state.init
      )

      state.getTypes()
    })
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
